// src/components/profile-detail/components/InfoCard.jsx
import React from "react";
import { Card, CardContent, Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";

const InfoCard = ({ 
  children, 
  title, 
  icon, 
  iconColor,
  sx = {} 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ 
      borderRadius: { xs: 2, md: 3 },
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      height: '100%',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: `0 8px 24px ${theme.palette.divider}`,
        borderColor: theme.palette.primary.light
      },
      ...sx
    }}>
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: { xs: 1.5, md: 2 },
          mb: { xs: 2, md: 3 },
          pb: { xs: 1.5, md: 2 },
          borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`
        }}>
          <Box sx={{
            width: { xs: 32, md: 40 },
            height: { xs: 32, md: 40 },
            borderRadius: { xs: 1.5, md: 2 },
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            {React.cloneElement(icon, { 
              fontSize: isMobile ? "small" : "medium",
              sx: { color: theme.palette.primary.main }
            })}
          </Box>
          <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ 
            color: theme.palette.primary.main, 
            fontWeight: 600,
            fontSize: { xs: '0.95rem', md: 'inherit' }
          }}>
            {title}
          </Typography>
        </Box>
        {children}
      </CardContent>
    </Card>
  );
};

export default InfoCard;